<template>
  <div>
    <Toolbar />
    <v-layout class="d-flex flex-column ma-0 pa-0 mt-md-5 mt-lg-5 mt-xl-5 px-5">
      <IconoHeader icono="card-account-phone" />
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col cols="12" class="ma-0 pa-0">
          <h3 class="texto-titulo text-center font-weight-bold">
            Referencia Familiar
          </h3>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-5">
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="10"
          lg="10"
          xl="10"
          class="ma-0 pa-0"
        >
          <p
            class="text-body-2 text-center ma-0 pa-0 grey--text text--darken-2"
          >
            <!-- Ingresa el nombre y telefono de algún familiar localizable -->
            <br />
            <span class="font-weight-bold"
              >Ingresa el nombre y telefono de algún familiar localizable</span
            >
          </p>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-container>
              <v-row justify="center" class="ma-0 pa-0">
                <v-col cols="12" xs="12" sm="12" md="10" lg="10" xl="10">
                  <v-text-field
                    outlined
                    type="text"
                    v-model="nombre"
                    label="Nombre completo"
                    required
                    class="mt-5"
                    :error-messages="nombreErrors"
                    @input="$v.nombre.$touch()"
                    @blur="$v.nombre.$touch()"
                    hide-details="auto"
                    tabindex="1"
                  >
                  </v-text-field>
                  <v-text-field
                    outlined
                    type="number"
                    v-model="telefono"
                    label="Telefono"
                    required
                    :error-messages="telefonoErrors"
                    @input="$v.telefono.$touch()"
                    @blur="$v.telefono.$touch()"
                    class="mt-5"
                    hide-details="auto"
                    maxlength="10"
                    minlength="10"
                    tabindex="2"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-0 pa-0 mt-4">
        <v-col
          cols="12"
          class="ma-0 pa-0 d-flex flex-row justify-center align-center"
        >
          <v-btn
            class="align-self-center"
            color="primary"
            elevation="2"
            type="submit"
            :disabled="!valid"
            @click="submit"
            >CONTINUAR<v-icon right light>mdi-arrow-right</v-icon></v-btn
          >
        </v-col>
      </v-row>
    </v-layout>
  </div>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import IconoHeader from '@/components/compartidos/IconoHeader.vue'
import { validationMixin } from 'vuelidate'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

import {
  required,
  minLength,
  maxLength,
  // sameAs,
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin, InsertaLogMixin],
  components: {
    Toolbar,
    IconoHeader,
  },
  name: 'Referencia',
  data: () => ({
    // datos: { nombre: '', telefono: '' },
    nombre: '',
    telefono: '',
    valid: false,
  }),

  validations: {
    nombre: {
      required,
    },
    telefono: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(10),
      onlyNumber: function (value) {
        return /^\d+$/.test(value)
      },
    },
  },
  computed: {
    nombreErrors() {
      const errors = []
      if (!this.$v.nombre.$dirty) return errors
      !this.$v.nombre.required && errors.push('El nombre es requerido')
      // this.$gtag.event('correoErrors', {
      //   event_category: 'change_in_window',
      //   event_label: 'No fue valido la contraseña',
      //   value: errors[0],
      // })
      return errors
    },
    telefonoErrors() {
      const errors = []
      if (!this.$v.telefono.$dirty) return errors
      !this.$v.telefono.required && errors.push('El telefono es requerido')
      !this.$v.telefono.minLength &&
        errors.push('El telefono debe ser de 10 digitos')
      !this.$v.telefono.maxLength &&
        errors.push('El telefono debe ser de 10 digitos')
      !this.$v.telefono.onlyNumber &&
        errors.push('El telefono debe tener solo digitos')
      return errors
    },
  },
  mounted() {
    this.InsertaLog()
  },
  created() {
    // console.log(this.$store.getters['credito/obtenerCredito'].tipoCredito)
    this.$store.getters['credito/obtenerCredito'].tipoCredito != 245
      ? this.$router.push('confirmacion')
      : ''
  },
  methods: {
    submit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('credito/establecerReferencia', {
          nombre: this.nombre,
          telefono: this.telefono,
        })
        this.$router.push('confirmacion')
      }
    },
    clear() {
      this.$v.$reset()
    },
  },
}
</script>
